import { Component, OnInit, ViewEncapsulation, OnDestroy, ChangeDetectorRef  } from '@angular/core';
import { AlertService } from 'src/app/core/services/alert.service';
import { AuthenticationService } from 'src/app/core/security/authentication.service';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { maskReportPackService } from 'src/app/core/services/mask-report-pack.service';
import { UntypedFormBuilder, FormGroup } from '@angular/forms';
import { BreadcrumbComponent } from 'src/app/shared/bread-crumb/bread-crumb.component';

import { ReportPackFilterComponent } from 'src/app/shared/report-pack-filter/report-pack-filter.component';
/**
 * Component
 */
@Component({
    selector: 'app-mask-report-pack',
    templateUrl: './mask-report-pack.component.html',
    styleUrls: ['./mask-report-pack.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MaskReportPackComponent implements OnInit, OnDestroy {
    public loading = false;
    selectedReportPack: any;

    queryModel: any;
    reportPackId: number;
    isDownloading = false;

    constructor(
        private alertService: AlertService,
        private maskReportPackService: maskReportPackService,
        private router: Router,
        private authService: AuthenticationService,
        private modalService: NgbModal,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit() {
        if (!this.authService.isPrivacyNoticeAcknowledged) {
            this.router.navigate(['/privacy-notice']);
        }
        this.queryModel = { reportPackId: 0, reportPackTitle: '' }
    }

    ngOnDestroy() {
        this.modalService.dismissAll();
    }

    onReportPackSelectionChange() {
        if (this.selectedReportPack) {
            this.queryModel.reportPackId = this.selectedReportPack.ReportPackID;
            this.queryModel.reportPackTitle = this.selectedReportPack.Title;
        }
        else this.queryModel.reportPackId = 0;
       
    }

    downloadMaskReportPack() {
        this.alertService.info('Masked Report pack file will be downloaded in a while!');
        this.isDownloading = true;
        this.maskReportPackService.downloadMaskedFile(this.queryModel)
            .finally(() => this.isDownloading = false);
    } 
    
}
